import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

export interface BrandDetailsShopAllProductsStyles {
    container?: InjectableCss;
    title?: InjectableCss;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const contentStyles: BrandDetailsShopAllProductsStyles = {
    container: {
        css: css`
            margin: 30px 15px;
        `,
    },
    title: {
        css: css`
            width: 100%;
            justify-content: center;
        `,
    },
};

const styles = contentStyles;

const BrandDetailsShopAllProducts: FC<Props> = ({ fields }) => {
    const { value: brand } = useContext(BrandStateContext);
    const { title } = fields;

    return (
        <Link
            {...styles.title}
            href={`${brand?.detailPagePath}/catalog/all`}
            typographyProps={{ ellipsis: true }}
            data-test-selector="brandShopAllProductsLink"
        >
            {translate(title)}
        </Link>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsShopAllProducts,
    definition: {
        group: "Brand Details",
        displayName: "Shop All Brand Products",
        allowedContexts: [BrandDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Shop All Brand Products",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
